import { CSSObject } from '@chakra-ui/react';

const baseFontFamily = 'Roboto';
const baseFontWeight = 'medium';
const baseTextColor = 'gray.500';

export const GreenIDText: CSSObject = {
  color: 'gray.500',
  mt: '2',
};

export const GreenIDContainer: CSSObject = {
  bg: 'white',
  borderRightRadius: 'lg',
  '#greenid-intro-content': {
    mt: '3',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    pb: '0',
    px: '10',
  },
  '#greenid-intro-content h1': {
    fontSize: 'sm',
    fontWeight: 'semibold',
  },
  '#greenid-intro-content #greenid-intro-words .lead': {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 'medium',
    fontSize: 'xs',
    color: 'gray.500',
    w: '90%',
    _last: {
      mb: '0',
    },
  },

  '#greenid-container .btn-primary': {
    fontSize: 'xs',
    fontFamily: 'heading',
    bgGradient: 'linear(to-b, gamma.500, gamma.600)',
    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.15)',
    borderRadius: 'base',
    textColor: 'white',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    width: 'auto',
    border: 'none',

    '&:focus': {
      backgroundColor: 'gamma.600',
    },
  },

  '#greenid-source-content': {
    border: 'none !important',
    bg: 'white',
    borderRightRadius: 'lg',
    px: '10',
  },

  // Source title styles
  '#greenid-source-content #greenid-source-header #greenid-source-title #greenid-source-title-heading':
    {
      fontFamily: baseFontFamily,
      fontWeight: `${baseFontWeight} !important`,
      color: baseTextColor,
      fontSize: 'xs',
    },

  // Form label styles
  '#greenid-source-body .row .form-group .control-label': {
    fontFamily: baseFontFamily,
    fontWeight: baseFontWeight,
    color: baseTextColor,
    fontSize: 'xs',
  },

  // Help icon styles
  '#greenid-source-body #greenid-FieldsForm .help-block': {
    fontFamily: baseFontFamily,
    fontWeight: baseFontWeight,
    color: baseTextColor,
    fontSize: 'xs',
  },

  '#greenid-source-content #greenid-source-header #greenid-source-title .greenid-modal-launch':
    {
      px: 0,
    },

  '#greenid-FieldsForm .control-label, #greenid-FieldsForm .greenid-helpicon, #greenid-source-title #greenid-source-title-heading, #greenid-source-title .greenid-modal-launch, #greenid-source-body .control-label':
    {
      color: 'gray.500',
    },
};
